import { Button, Card, CardContent, FormHelperText, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { addApi, getApis } from "../../../Services/API/AtsApi";
import DropdownComponent from "../../Dropdown/DropdownComponent";
import LoadingBar from "../../LoadingBar/LoadingBar";
import { StyledTextField } from "../../TextField/TextField";
import KenexaAPISection from "./KenexaAPISection";
import PeopleMatterAPISection from "./PeopleMatterAPISection";
import TaleoAPISection from "./TaleoAPISection";
import WorkableAPISection from "./WorkableAPISection";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
  textField: {
    "& .Mui-error": {
      color: theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.error.main,
    },
  },
}));

export default function InboundAPIModal({ openModal, setData, setShowSignifier, setShowError, clientID }) {
  const classes = useStyles();

  const [feedTypes, setFeedTypes] = useState([]);
  const [showInputError, setShowInputError] = useState(false);
  const [name, setName] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [outputFileName, setOutputFileName] = useState("");
  const [version, setVersion] = useState("");
  const [credential, setCredential] = useState("");
  const [userID, setUserID] = useState("");
  const [siteID, setSiteID] = useState("");
  const [mappingFileName, setMappingFileName] = useState("");
  const [processor, setProcessor] = useState("");
  const [additionalQuestionIds, setAdditionalQuestionIds] = useState("");
  const [country, setCountry] = useState("");
  const [reqNumberFieldID, setReqNumberFieldID] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [businessUnits, setBusinessUnits] = useState("");
  const [addPostedDate, setAddPostedDate] = useState(false);
  const [addProcessing, setAddProcessing] = useState(false);
  const [feedType, setFeedType] = useState("");

  const data = {
    ClientID: clientID === "" ? null : clientID,
    Name: name === "" ? null : name,
    AssemblyName: feedType === "" ? null : feedType.name,
    EndPoint: endpoint === "" ? null : endpoint,
    FeedFileName: outputFileName === "" ? null : outputFileName,
    CompanyName: companyName === "" ? null : companyName,
    BusinessUnits: businessUnits === "" ? null : businessUnits,
    Version: version === "" ? null : version,
    UserId: userID === "" ? null : userID,
    Credential: credential === "" ? null : credential,
    SiteId: siteID === "" ? null : siteID,
    Processor: processor === "" ? null : processor,
    Questions: additionalQuestionIds === "" ? null : additionalQuestionIds,
    MappingFileName: mappingFileName === "" ? null : mappingFileName,
    CountryValue: country === "" ? null : country,
    AddPostedDate: addPostedDate,
    PostedDateReqNumberId: reqNumberFieldID === "" ? null : reqNumberFieldID,
  };

  const checkAllEntered = () => {
    if (name === "" || endpoint === "" || outputFileName === "") {
      return false;
    }
    switch (feedType) {
      case null:
        return false;
      case "BrassRing":
        if (
          version === "" ||
          credential === "" ||
          userID === "" ||
          siteID === "" ||
          mappingFileName === "" ||
          processor === "" ||
          reqNumberFieldID === ""
        ) {
          return false;
        }
        return true;
      case "PeopleMatter":
        if (companyName === "" || businessUnits === "") {
          return false;
        }
        return true;
      case "TaleoEnterprise":
        if (version === "" || userID === "" || credential === "") {
          return false;
        }
        return true;
      case "Workable":
        if (mappingFileName === "" || processor === "") {
          return false;
        }
        return true;
      default:
        return true;
    }
  };

  const submitData = () => {
    if (checkAllEntered()) {
      setAddProcessing(true);
      addApi(data).then(() => {
        getApis(clientID).then((res) => {
          setShowSignifier(true);
          if (res) {
            setData(res);
            openModal(false);
          } else {
            setShowError(true);
          }
          setAddProcessing(false);
        });
      });
    } else {
      setShowInputError(true);
    }
  };

  const renderExtraFields = () => {
    if (feedType === "") {
      return;
    }
    switch (feedType.name) {
      case null:
        return null;
      case "BrassRing":
        return (
          <KenexaAPISection
            version={version}
            setVersion={setVersion}
            credential={credential}
            setCredential={setCredential}
            userID={userID}
            setUserID={setUserID}
            siteID={siteID}
            setSiteID={setSiteID}
            mappingFileName={mappingFileName}
            setMappingFileName={setMappingFileName}
            processor={processor}
            setProcessor={setProcessor}
            reqNumberFieldID={reqNumberFieldID}
            setReqNumberFieldID={setReqNumberFieldID}
            additionalQuestionIds={additionalQuestionIds}
            setAdditionalQuestionIds={setAdditionalQuestionIds}
            country={country}
            setCountry={setCountry}
            addPostedDate={addPostedDate}
            setAddPostedDate={setAddPostedDate}
            showInputError={showInputError}
          />
        );
      case "PeopleMatter":
        return (
          <PeopleMatterAPISection
            companyName={companyName}
            setCompanyName={setCompanyName}
            businessUnits={businessUnits}
            setBusinessUnits={setBusinessUnits}
            showInputError={showInputError}
          />
        );
      case "TaleoEnterprise":
        return (
          <TaleoAPISection
            serviceVersion={version}
            setServiceVersion={setVersion}
            username={userID}
            setUsername={setUserID}
            password={credential}
            setPassword={setCredential}
            showInputError={showInputError}
          />
        );
      case "Workable":
        return (
          <WorkableAPISection
            token={mappingFileName}
            setToken={setMappingFileName}
            additonalProperties={additionalQuestionIds}
            setAdditonalProperties={setAdditionalQuestionIds}
            requisitionStatuses={processor}
            setRequisitionStatuses={setProcessor}
            showInputError={showInputError}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    setFeedTypes([
      { name: "BrassRing" },
      { name: "PeopleMatter" },
      { name: "TaleoEnterprise" },
      { name: "Workable" },
    ]);
  }, []);

  return (
    <div className={classes.root}>
      <LoadingBar loading={addProcessing} />
      <Grid>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid xs={12} sm={12} item>
                <p>Add API</p>
              </Grid>
              <Grid item xs={12} sm={12}>
                <DropdownComponent
                  currValue={feedType}
                  items={feedTypes}
                  property="name"
                  title="Feed Type"
                  handleChange={(value) => setFeedType(value)}
                />
                {showInputError && feedType === null && (
                  <FormHelperText className={classes.error}>Feed Type Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  label="Name"
                  value={name}
                  variant="standard"
                  fullWidth
                  required
                  error={showInputError && name === ""}
                  className={classes.textField}
                  onChange={(e) => setName(e.target.value)}
                />
                {showInputError && name === "" && (
                  <FormHelperText className={classes.error}>Name Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  label="End Point"
                  value={endpoint}
                  error={showInputError && endpoint === ""}
                  className={classes.textField}
                  variant="standard"
                  fullWidth
                  required
                  onChange={(e) => setEndpoint(e.target.value)}
                />
                {showInputError && endpoint === "" && (
                  <FormHelperText className={classes.error}>End Point Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  label="Output Filename"
                  value={outputFileName}
                  error={showInputError && outputFileName === ""}
                  className={classes.textField}
                  variant="standard"
                  fullWidth
                  required
                  onChange={(e) => setOutputFileName(e.target.value)}
                />
                {showInputError && outputFileName === "" && (
                  <FormHelperText className={classes.error}>Output Filename Required</FormHelperText>
                )}
              </Grid>
              {renderExtraFields()}
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ color: "primary", marginTop: "20px" }}
                  type="submit"
                  variant="outlined"
                  disabled={addProcessing}
                  onClick={() => openModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginTop: "20px", marginLeft: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={addProcessing}
                  onClick={() => submitData()}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
